import React from 'react';
import Link from 'gatsby-link';
import _ from 'lodash';

// Utils
import { createSlugFromTitle } from '../utils';

const SitemapPage = ({ data }) => {

  return (
    <div>
      <ul>
        {data.allGoogleSheetFoodsRow.edges.map(({ node }) => <li key={node.id}><Link to={createSlugFromTitle(node.title)}>{node.title}</Link></li>)}
      </ul>
    </div>
  );
};

export const query = graphql`
  query SitemapQuery {
    allGoogleSheetFoodsRow {
      edges {
        node {
          id
          title
          description
          themecolor
          textcolor
          bestknownfor
          toomuchcauses
          tags
        }
      }
    }
    allGoogleSheetLeaderboardsRow {
      edges {
        node {
          id
          title
          items
        }
      }
    }
    allGoogleSheetQuestionsRow {
      edges {
        node {
          id
          question
          answer
        }
      }
    }
    allGoogleSheetResearchRow {
      edges {
        node {
          id
          title
          heading
          prevents
          reliability
          link1
          link2
          link3
        }
      }
    }
  }
`;

export default SitemapPage;



// WEBPACK FOOTER //
// ./src/pages/sitemap.js